// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export default {
    "dirty": false,
    "raw": "c044944",
    "hash": "c044944",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c044944",
    "semverString": null
};
/* tslint:enable */
